/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import React, { FunctionComponent } from "react";
import styled from "../../../themes/global";
import { HTMLCustomProps } from "../../../types/css";

export const Ebutton = styled("button")`
  background-color: ${(props) => props.theme.color.primary};
  border-radius: 4px;
  color: ${(props) => props.theme.color.white};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border: none;
  margin-right: auto;
  margin-left: auto;
  outline: none;
  padding: 16px 18px;
  position: relative;
  &:active {
    transform: translateY(2px);
    box-shadow: none;
  }
`;

interface ButtonProps {
  type?: any;
}

const Button: FunctionComponent<HTMLCustomProps<HTMLButtonElement> &
  ButtonProps> = ({ children, ...rest }) => {
  return <Ebutton {...rest}>{children}</Ebutton>;
};

export default Button;
